import React from 'react'
import {Link} from "react-router-dom";
import {GoSearch} from "react-icons/go";
import { GlobalDataState } from '../Context';
import {ImHome} from "react-icons/im"
const SearchAll = () => {
    const {settextSearch}=GlobalDataState();
  return (
    <div style={{height:'15vh',backgroundColor:"orange",borderRadius:"2rem"}}>
        <h1 style={{marginLeft:"1rem"}}>SEARCH MORE</h1>
        <input  style={{width:'70vw',height:'2rem',borderRadius:"1rem",marginLeft:'7rem'}} onChange={(e)=>settextSearch(e.target.value)}></input>
        <div style={{marginLeft:'85rem',marginTop:"-5rem",fontSize:'2rem'}}>
        <Link to={'/favourites'}>
            <ImHome />
        </Link>
        </div>
        <div style={{marginLeft:'75rem',marginTop:'0rem',fontSize:'2rem'}}>
        <Link to={'/search'}>
             <buton><GoSearch/></buton>
        </Link>
        </div>
    </div>
  )
}

export default SearchAll